__turbopack_context__.v({
  "button": "Button-module-scss-module__5EH-_G__button",
  "color-accent": "Button-module-scss-module__5EH-_G__color-accent",
  "color-error": "Button-module-scss-module__5EH-_G__color-error",
  "color-primary": "Button-module-scss-module__5EH-_G__color-primary",
  "color-soft": "Button-module-scss-module__5EH-_G__color-soft",
  "full-width": "Button-module-scss-module__5EH-_G__full-width",
  "icon": "Button-module-scss-module__5EH-_G__icon",
  "is-loading": "Button-module-scss-module__5EH-_G__is-loading",
  "multiline": "Button-module-scss-module__5EH-_G__multiline",
  "rounded": "Button-module-scss-module__5EH-_G__rounded",
  "selected": "Button-module-scss-module__5EH-_G__selected",
  "size-lg": "Button-module-scss-module__5EH-_G__size-lg",
  "size-md": "Button-module-scss-module__5EH-_G__size-md",
  "size-sm": "Button-module-scss-module__5EH-_G__size-sm",
  "spin": "Button-module-scss-module__5EH-_G__spin",
  "spinner": "Button-module-scss-module__5EH-_G__spinner",
  "variant-fill": "Button-module-scss-module__5EH-_G__variant-fill",
  "variant-ghost": "Button-module-scss-module__5EH-_G__variant-ghost",
  "variant-outlined": "Button-module-scss-module__5EH-_G__variant-outlined",
});
